/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AcceptInviteOptions, AcceptInviteResponses } from '../../models/AcceptInvite'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Accept Invite
 * {@link /org/invite/accept}
 */
export function acceptInvite<ThrowOnError extends boolean = true>(options: Options<AcceptInviteOptions, ThrowOnError>): Promise<UnwrappedResult<AcceptInviteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/org/invite/accept', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AcceptInviteResponses, ThrowOnError>>
}
